export const REACT_QUERY_OPTIONS_NEVER_REFETCH = {
  staleTime: Infinity,
  cacheTime: Infinity,
};
